import { FiltroLista, IFiltroLista } from 'src/app/filter/filtro-lista';


export interface IFiltroListaSolicitacaoCompra extends IFiltroLista{

  CC1NUM: string;
  CC1FORNECE: string;
  CC1LOJA: string;
  CC1FORNECELOJA: string;
  CC1SOLICIT: string;
  CC1USER: string;
  CC1USER_IN: string | Array<string>;
  DC1EMISSAO_DE: Date | undefined;
  DC1EMISSAO_ATE: Date | undefined;
  DC1DATPRF_DE: Date | undefined;
  DC1DATPRF_ATE: Date | undefined;

}

export class FiltroListaSolicitacaoCompra extends FiltroLista {

  dados: IFiltroListaSolicitacaoCompra = this.setDefault();
  timeout = this.getDataString(3650);

  public setDefault(): IFiltroListaSolicitacaoCompra {
    return {
      page: 1,
      pageSize: 20,
      filter: '',
      order: '',

      CC1NUM: '',
      CC1FORNECE: '',
      CC1LOJA: '',
      CC1FORNECELOJA: '',
      CC1SOLICIT: '',
      CC1USER: '',
      CC1USER_IN: '',
      DC1EMISSAO_DE: this.getData(-30),
      DC1EMISSAO_ATE: this.getData(),
      DC1DATPRF_DE: undefined,
      DC1DATPRF_ATE: undefined,
    };
  }

}
